import { useEffect } from 'react'
import { isMobileOnly } from 'react-device-detect'
import { androidStore, iosStore } from '../constants/urls'

export const WorkspaceInvitationsPage = () => {
  useEffect(() => {
    if (isMobileOnly) {
      const isAndroid = /Android/i.test(navigator.userAgent)

      window.location.href = isAndroid ? androidStore : iosStore
    } else {
      window.location.href = 'https://portal.twiceme.com/workspaces'
    }
  }, [])

  return (
    <div className="flex justify-center items-center h-screen">
      Redirecting.....
    </div>
  )
}
